import { render, staticRenderFns } from "./realTimeVideoGB.vue?vue&type=template&id=325fdd5c&scoped=true&"
import script from "./realTimeVideoGB.vue?vue&type=script&lang=js&"
export * from "./realTimeVideoGB.vue?vue&type=script&lang=js&"
import style0 from "./realTimeVideoGB.vue?vue&type=style&index=0&id=325fdd5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325fdd5c",
  null
  
)

export default component.exports